// Fetches per-role descriptive copy from the Builder.io `session-role` data
// model and returns a map keyed by the role tag id (e.g. `sb-session_role-...`).
// Each value is { heading, copy }. Client/Shannon edit this in Builder without
// a deploy. Falls back to an empty map on any error so the agenda still renders.
export const getRoleCopy = async () => {
    const apiKey = getEnv('builderApi');
    if (!apiKey) return {};
    try {
        const res = await $fetch('https://cdn.builder.io/api/v3/content/session-role', {
            params: {
                apiKey,
                limit: 100,
                fields: 'data',
                cacheSeconds: 300,
            },
        });
        const map = {};
        for (const entry of (res?.results || [])) {
            const d = entry?.data || {};
            if (d.roleId) {
                map[d.roleId] = {
                    heading: d.heading || '',
                    copy: d.copy || '',
                };
            }
        }
        return map;
    } catch (e) {
        console.error('[agenda] role-copy fetch failed', e);
        return {};
    }
};
